import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
// @mui
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import Logo from 'src/components/logo';
import { NavSectionVertical } from 'src/components/nav-section';
import Scrollbar from 'src/components/scrollbar';
import { usePathname, useRouter } from 'src/routes/hooks';
//
import { NavToggleButton, NavUpgrade } from '../_common';
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import FileManagerNewFolderDialog from 'src/sections/file-manager/file-manager-new-folder-dialog';
import { useBoolean } from 'src/hooks/use-boolean';
import { useSnackbar } from 'src/components/snackbar';
import { useUploadImageMutation } from 'src/store/Reducer/file';
import { useAddFolderMutation } from 'src/store/Reducer/folder';
import { toast } from 'react-toastify';

// ----------------------------------------------------------------------

export default function NavVertical({ openNav, onCloseNav }) {
  const { user } = useMockedUser();

  const pathname = usePathname();

  const lgUp = useResponsive('up', 'lg');

  const [folderName, setFolderName] = useState('');

  const [caption, setCaption] = useState('');

  const [selectedCategory, setSelectedCategory] = useState('');

  const [files, setFiles] = useState([]);

  const [creatingLoading, setCreatingLoading] = useState(false);

  const is_confidential = useBoolean();

  const { enqueueSnackbar } = useSnackbar();

  const [uploadImage] = useUploadImageMutation();

  const [addFolder] = useAddFolderMutation();

  const { data, openModal, handleOpenModal, handleCloseModal } = useNavData();

  // const [location, setLocation] = useState(null);

  const router = useRouter();

  // const getLocationFromCoords = async coords => {
  //   try {
  //     const response = await fetch(
  //       `https://nominatim.openstreetmap.org/reverse?lat=${coords.latitude}&lon=${coords.longitude}&format=json&addressdetails=1`,
  //     );
  //     return await response.json();
  //   } catch (error) {
  //     console.error('Error fetching address from coordinates:', error);
  //   }
  // };

  // useEffect(() => {
  //   navigator.geolocation.getCurrentPosition(
  //     async (position) => {
  //       let response = await getLocationFromCoords(position.coords);
  //       setLocation(response?.display_name || 'Unknown location');
  //     },
  //     (err) => console.error("Error getting location:", err)
  //   );

  // }, [])


  const handleChangeFolderName = useCallback((event) => {
    setFolderName(event.target.value);
  }, []);

  const handleCreateNewFolder = async () => {
    try {
      if ((!folderName.trim() && enqueueSnackbar('Folder name is required', { variant: 'error' })) ||
        (!selectedCategory && enqueueSnackbar('Please select a category', { variant: 'error' })) ||
        ((!files || files?.length === 0) && enqueueSnackbar('Please upload at least one file', { variant: 'error' }))
      ) return;

      setCreatingLoading(true);

      const formData = new FormData();

      files.forEach((file) => {
        formData.append('files[]', file);
      });

      formData.append('UPLOAD_IDENTIFIER', folderName);

      const uploadResult = await uploadImage(formData).unwrap();

      const newData = {
        category_id: selectedCategory,
        project: folderName,
        caption,
        files: uploadResult?.data?.uploaded,
        is_confidential: is_confidential.value
      }
      const responce = await addFolder(newData).unwrap();
     if (!responce?.error) {
      handleCloseModal();
      enqueueSnackbar('New Folder uploaded successfully')
       window.location.reload();
     }
    } catch (error) {
      setCreatingLoading(false)
      toast.error(error?.data?.message || 'Failed to Upload Folder');
    } finally {
      setCreatingLoading(false);
    }
  };


  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Logo sx={{ mt: 3, ml: 4, mb: 1, cursor: "pointer" }} onClick={() => router.push('/')} />

      <NavSectionVertical
        data={data}
        config={{
          currentRole: user?.role || 'admin',
        }}
      />

      <Box sx={{ flexGrow: 1 }} />

      {/* <NavUpgrade /> */}
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_VERTICAL },
      }}
    >
      <NavToggleButton />

      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: 'fixed',
            width: NAV.W_VERTICAL,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      <FileManagerNewFolderDialog
        open={openModal}
        creatingLoading={creatingLoading}
        onClose={handleCloseModal}
        title="Upload New Image / Video"
        files={files}
        setFiles={setFiles}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        setCaption={setCaption}
        caption={caption}
        folderName={folderName}
        onChangeFolderName={handleChangeFolderName}
        onCreate={handleCreateNewFolder}
        confidential={is_confidential.value}
        onToggleConfidential={is_confidential.onToggle}
      />

    </Box>
  );
}

NavVertical.propTypes = {
  onCloseNav: PropTypes.func,
  openNav: PropTypes.bool,
};
